import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';

const StyledBox = styled(Box)(({ theme }) => ({
  '&.MTHSSContainer': {
    height: theme.spacing(61.625),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    [theme.breakpoints.down('lg')]: {
      height: theme.spacing(30.25),
    },
  },
}));

const MotorcycleTripHeaderSectionSkeleton = () => (
  <StyledBox className="MTHSSContainer">
    <Skeleton variant="rectangular" width="60%" height={150} />
  </StyledBox>
);
export { MotorcycleTripHeaderSectionSkeleton };
